import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import Select from "react-select"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { ErrorContext } from "../../context/errorContext"
import {JourneyContext} from "../../context/journeyContext"
import * as keywordMapping from "../../../../static/nvestKeyMapping.json"
import { productRenderChecker,getValueFromLookup } from "../../services/helperFunctions"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import * as lookup from "../../../../static/lookup.json"

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;
    
    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 1rem 0;
      padding-bottom: 0;
    }

    .css-1uccc91-singleValue{
      color:inherit;
      // font-size: 1.6rem;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }

    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
      background:var(--lumiq-bg)

    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background-color: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

export default function ComponentProductSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [options, setOptions] = useState({})

  const validate = (target) =>  {
    if(props.data.required  && options && options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length > 0){
      if((sectionState.sectionData[props.data.formControlKey] === "") || (!sectionState.sectionData[props.data.formControlKey]) ){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: `Please Select ${lineCapital(getValueFromLookup(
              "label",
              props.data.label
            )) || props.data.label}`
          })
        })
      }else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      if(target.value){
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }else{
      setErrorState(prev => {
        return({
          ...prev,
          [props.data.formControlKey]: ""
        })
      })
    }
    return
  }

  //FOR VALIDATION
  useEffect(() => {
    validate({value: sectionState.sectionData[props.data.formControlKey]?? ""})
  },[sectionState.sectionData[props.data.formControlKey], options[props.data.formControlKey]])
console.log(conditionState?.["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.CPSpouseOccupationQuestion"]);
  useEffect(() => {
    if(props.sectionId == "iSelect360CPSpouseCoverDetails" && props.data.formControlKey === "occupation") {
      if(sectionState.sectionData?.["CPSpouseOccupationQuestion"]){
        let spouseWorkingLookup = "occupation_SPOUSE_NONWORKING"
        if(sectionState.sectionData?.["CPSpouseOccupationQuestion"] === "W"){
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: lookup["occupation_SPOUSE_WORKING"]?.[0]
            })
          })
          spouseWorkingLookup = "occupation_SPOUSE_WORKING"
        }else{
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: lookup["occupation_SPOUSE_NONWORKING"]?.[0]
            })
          })
          spouseWorkingLookup = "occupation_SPOUSE_NONWORKING"
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["occupation"]: "",
            }
          })
        })
          
      }
    } else if(props.sectionId == "youngTermCPSpouseCoverDetails" && props.data.formControlKey === "occupation") {
      if(sectionState.sectionData?.["CPSpouseOccupationQuestion"]){
        let spouseWorkingLookup = "occupation_SPOUSE_NONWORKING"
        if(sectionState.sectionData?.["CPSpouseOccupationQuestion"] === "W"){
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: lookup["occupation_SPOUSE_WORKING"]?.[0]
            })
          })
          spouseWorkingLookup = "occupation_SPOUSE_WORKING"
        }else{
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: lookup["occupation_SPOUSE_NONWORKING"]?.[0]
            })
          })
          spouseWorkingLookup = "occupation_SPOUSE_NONWORKING"
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["occupation"]: "",
            }
          })
        })
          
      }
    }
  },[sectionState.sectionData?.["CPSpouseOccupationQuestion"]])

  useEffect(() => {
    let optionsFromLookup = props.options
    console.log(props.nvestFilterResult, "dfdfefe")
    let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]
    let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
    if(!requiredObjectInNvestFilterResult || !optionNameInMappingJson){
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: optionsFromLookup
        })
      })
      return 
    }
    // console.log(requiredObjectInNvestFilterResult, props.data.formControlKey, "Dfgrgr")
    let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
    // console.log(parentUnifiedkeyofProposalJSON, props.data.formControlKey, "dfrgthyj")
    //reverseMapping the value
    if(parentUnifiedkeyofProposalJSON){
        let reverseKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === parentUnifiedkeyofProposalJSON.toLowerCase())
        if(reverseKey){
            if(conditionState[reverseKey]){
                let newOptions = {}
                console.log(3333333333333,journeyState )
  
                
                  requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
                    if(productRenderChecker(element.ParentUnifiedCode,conditionState[reverseKey])){
                      if(props.data.formControlKey=="monthlyIncomePayout2" || props.data.formControlKey=="monthlyIncomePayout" || props.data.formControlKey == "iSelect360monthlyIncomePayout2")
                      {
                        newOptions = props.options
                      }
                        else if(requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key){
                            newOptions[requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key] = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
                          }
                      }
                  })
                
                setOptions(prev => {
                  return ({
                    ...prev,
                    [props.data.formControlKey]: newOptions
                  })
                })
                if(Object.keys(newOptions).length==0)
                {
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionData: {
                        ...prev.sectionData,
                        [props.data.formControlKey]: "",
                      },
                    }
                  })
                }
            }else{
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: []
                })
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
                }
              })
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: ""
                  }
                }
              })
            }
        }
    }else{
      let newOptions = []
      requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
        if(requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key){
            newOptions[requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key] = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
        }
      })
      // console.log(newOptions, "product is null")
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: newOptions
        })
      })
    }
  }, [props.nvestFilterResult, conditionState?.[props.watchKey]])


  //UseEffect To autoFill Values
  useEffect(() => {
    autoFill()
  }, [sectionState.sectionData[props.data.formControlKey]])

  const autoFill = () => {
    console.log("function called", sectionState)
    if ((props.sectionId === "CPCustomizePlanSection" && props.data.formControlKey === "CPCustomizePlanPaymentFrequency") || (props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency") || (props.sectionId === "youngTermCPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")) {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "iSelectJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CPCustomizePlanSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CPCustomizePlan")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CPCustomizePlanPremiumPaymentTerm")
      } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPCustomizePlanSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPCustomizePlan")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm")
      } else if (props.journeyIdFromStrapi === "youngTermPlanJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageYoungTermCalculatePremium")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "youngTermCPCustomizePlanSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "youngTermCPCustomizePlan")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (sectionState.sectionData[props.data.formControlKey] === "SG"){
        if(!(sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] === "1" || sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] === "1")){
          if (props.journeyIdFromStrapi === "iSelectJourney") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CPCustomizePlanPremiumPaymentTerm"]: "1",
                }
              })
            })
          } else if (props.journeyIdFromStrapi === "ISelect360Journey" || props.journeyIdFromStrapi === "youngTermPlanJourney") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["iSelect360CPCustomizePlanPremiumPaymentTerm"]: "1",
                }
              })
            })
          }
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          console.log(temp, "iimp")
  
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
  
          props.saveApplicationAndCallBi("iSelect360CPCustomizePlanPremiumPaymentTerm", "1")
        }
      } else {
        if(props.journeyIdFromStrapi === "iSelectJourney"){
          if(sectionState.sectionData && sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] && sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] === "1"){
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CPCustomizePlanPremiumPaymentTerm"]: sectionState.sectionData["CPCustomizePlanPolicyTerm"],
                }
              })
            }) 
            props.saveApplicationAndCallBi("CPCustomizePlanPremiumPaymentTerm", sectionState.sectionData["CPCustomizePlanPolicyTerm"])
          }
        } else if (props.journeyIdFromStrapi === "ISelect360Journey" || props.journeyIdFromStrapi === "youngTermPlanJourney") {
          if(sectionState.sectionData && sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] && sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] === "1"){
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["iSelect360CPCustomizePlanPremiumPaymentTerm"]: sectionState.sectionData["iSelect360CPCustomizePlanPolicyTerm"],
                }
              })
            })
            props.saveApplicationAndCallBi("iSelect360CPCustomizePlanPremiumPaymentTerm", sectionState.sectionData["iSelect360CPCustomizePlanPolicyTerm"])
          }
          
        }
        
        let temp = journeyState.journeySteps
        console.log(temp, "dfg")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        console.log(temp, "iimp")
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }    
    else if(props.data.formControlKey.toLowerCase() === "occupation") {
      if (props.sectionId == "iSelect360CPSpouseCoverDetails"){

        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if(props.journeyIdFromStrapi === "ISelect360Journey"){
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "spousetelemr")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "Exactnatureoccupation")
        
        if(sectionState.sectionData[props.data.formControlKey] === "1"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "611",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }else if(sectionState.sectionData[props.data.formControlKey] === "4"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "77",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
        else if(sectionState.sectionData[props.data.formControlKey] === "6"){
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["Exactnatureoccupation"]: "664",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }else{setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["CPResidentAndOccupationNatureIndustries"]: "",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        console.log(temp, "iimp")

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        }
      }
    }
    
  }

  const handleChange = target => {
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    // console.log(conditionState, "dhdhdj")
    validate(target)
    if((props.sectionId === "CPCustomizePlanSection" && props.data.formControlKey === "CPCustomizePlanPaymentFrequency") || 
    (props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency") ||
    (props.sectionId === "youngTermCPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")
    ){
      if(target.value !== "SG" && 
      ((props.journeyIdFromStrapi === "ISelect360Journey" && sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] !== "1")
       || (props.journeyIdFromStrapi === "iSelectJourney" && sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] !== "1") ||
       (props.journeyIdFromStrapi === "youngTermPlanJourney" && sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] !== "1"))){
        props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
      }
    }else{
      props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    }
    
    // console.log(sectionState, "section state")
  }

  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }


  let optionsToShow
  if(options[props.data.formControlKey]){
    optionsToShow = Object.entries(options[props.data.formControlKey]).map(([key, val]) => ({
        value: key,
        label: val,
    }))
  }

  if (
    props.pageId === "calculatePremiumPage" &&
    props.sectionId === "CPCustomizePlanSection" &&
    props.data.formControlKey === "CPCustomizePlanPaymentFrequency"
  ) {
      let conditionStatePlanOptionKey = "calculatePremiumPage.CPCustomizePlanSection.CPCustomizePlanQuestionOne"
      let policyTermKey = "CPCustomizePlanPolicyTerm"
      if (Object.keys(journeyState.optionValues).length) {
        let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData[policyTermKey]]
        if (options) {
          console.log(options, "OptionsAfterA60")
          let hasOneInPPT =  Object.keys(options).some(key => {
            if(key === "1"){
              return true
            }
          })
          if(!hasOneInPPT){
            optionsToShow = [
              {
                value: "12",
                label: "ANNUALLY"
              },
              {
                value: "01",
                label: "MONTHLY"
              },
              {
                value: "03",
                label: "QUARTERLY"
              },
              {
                value: "06",
                label: "SEMI-ANNUALLY"
              },
            ]
          }
        }
      }
    
  }

  if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPCustomizePlanSection" &&
    props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency" 
  ) {
    let conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
    let policyTermKey = "iSelect360CPCustomizePlanPolicyTerm"
    if (Object.keys(journeyState.optionValues).length) {
      let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData[policyTermKey]]
      if (options) {
        console.log(options, "OptionsAfterA60")
        let hasOneInPPT =  Object.keys(options).some(key => {
          if(key === "1"){
            return true
          }
        })
        if(!hasOneInPPT){
          optionsToShow = [
            {
              value: "12",
              label: "ANNUALLY"
            },
            {
              value: "01",
              label: "MONTHLY"
            },
            {
              value: "03",
              label: "QUARTERLY"
            },
            {
              value: "06",
              label: "SEMI-ANNUALLY"
            },
          ]
        }
      }
    }
  }
  if (
    props.pageId === "PageYoungTermCalculatePremium" &&
    props.sectionId === "youngTermCPCustomizePlanSection" &&
    props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency" 
  ) {
    let conditionStatePlanOptionKey = "PageYoungTermCalculatePremium.youngTermCPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
    let policyTermKey = "iSelect360CPCustomizePlanPolicyTerm"
    if (Object.keys(journeyState.optionValues).length) {
      let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData[policyTermKey]]
      if (options) {
        console.log(options, "OptionsAfterA60")
        let hasOneInPPT =  Object.keys(options).some(key => {
          if(key === "1"){
            return true
          }
        })
        if(!hasOneInPPT){
          optionsToShow = [
            {
              value: "12",
              label: "ANNUALLY"
            },
            {
              value: "01",
              label: "MONTHLY"
            },
            {
              value: "03",
              label: "QUARTERLY"
            },
            {
              value: "06",
              label: "SEMI-ANNUALLY"
            },
          ]
        }
      }
    }
  }


  // if(props.sectionId == "iSelect360CPSpouseCoverDetails" && props.data.formControlKey == "occupation") {
  //   // console.log(conditionState?.["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.CPSpouseOccupationQuestion"]);

  //   if(sectionState.sectionData?.["CPSpouseOccupationQuestion"]){

      
     
  //     if(sectionState.sectionData?.["CPSpouseOccupationQuestion"] === "W"){
  //       spouseWorkingLookup = "occupation_SPOUSE_WORKING"
  //     }else{
  //       spouseWorkingLookup = "occupation_SPOUSE_NONWORKING"
  //     }

  //     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = spouseWorkingLookup
  //     console.log(temp);

  //     setJourneyState(prev => {
  //       return ({
  //         ...prev,
  //         journeySteps: temp
  //       })
  //     })
  //     setSectionState(prev => {
  //       return ({
  //         ...prev,
  //         sectionData: {
  //           ...prev.sectionData,
  //           ["occupation"]: "",
  //         }
  //       })
  //     })
        
  //   }
  // }

  
  return (
    <>
      {options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 &&<SelectContainer channel={props.channel} className={`input-container qw ${props.data.disabled?'disable-input':''} ${props.data.freeze?'freeze-input':''}` }>
        {
            options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 &&
            <label htmlFor={props.data.label} className="input-label">
            {/* {props.data.label} */}
            {lineCapital(getValueFromLookup(
                  "label",
                  props.data.label
                )) || props.data.label}
            
            </label>
        }
        {
            options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 &&  
            <Select
            // className="form-control"
            // styles={customStyles}
            options={optionsToShow}
            name={props.data.label}
            key={props.data.formControlKey}
            id="InputSelect"
            required={props.data.required}
            onChange={handleChange}
            // className={props.data.disabled?"disable-input":""}
            tabIndex={props.data.disabled || props.data?.freeze?-1:0}

            value={
                sectionState.sectionData[props.data.formControlKey]
                ? getKeyByValue(
                    optionsToShow,
                    sectionState.sectionData[props.data.formControlKey]
                    )
                : ""
            }
            onBlur={e => validate(e.target)}
            ></Select>
        }
        {
            options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 &&  
            <span className="input-error">
            {props.showError && errorState[props.data.formControlKey]}
            </span>
        }
      </SelectContainer>}
    </>
  )
}
